import { css } from 'styled-components';
import {
  BreakpointQueryName, ThemedFunctor, TypographyName, getTypography,
} from '@doveit/lego';

export const content: ThemedFunctor = ({ theme, $contentCentered }) => css`
  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    ${$contentCentered && `
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    `}
  }
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H2)};
  text-transform: uppercase;
  color: ${theme.palettes.brand.primary};
`;

export const grid = (inverted: boolean) => ({ theme }) => css`
  flex-direction: ${inverted ? 'column-reverse' : 'column'};

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-direction: ${inverted ? 'row-reverse' : 'row'};
  }
`;
